import HundredBricksAPIError from '../../HundredBricksAPIError';
class CapitalGainError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('CapitalGainError', ...args);
    }
}
export default CapitalGainError;
